import React, { FC } from "react";
import styled from "styled-components";

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start; /* Aligns content to the top */
  min-height: 100vh; /* Full viewport height to maintain background color */
  padding-top: 20px; /* Add some spacing from the top */
  background-color: #f0f0f0; /* Light grey background */
`;

const Panel = styled.div`
  background-color: #ffffff; /* White panel */
  padding: 20px 40px; /* Add some padding */
  border-radius: 10px; /* Rounded corners */
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1); /* Subtle shadow */
  text-align: center; /* Center the text */
  max-width: 500px; /* Limit panel width */
  width: 100%; /* Responsive */
`;

const StyledLink = styled.a`
  color: #007bff; /* Blue link color */
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

const RemoveAccount: FC = () => {
  return (
    <Container>
      <Panel>
        <h1>Exclusão de dados:</h1>
        <h3>
          Para solicitar a exclusão de seus dados no aplicativo, entre em
          contato através do e-mail{" "}
          <StyledLink href="mailto:bastatransito.app@gmail.com">
            bastatransito.app@gmail.com
          </StyledLink>
          .
        </h3>
      </Panel>
    </Container>
  );
};

export default RemoveAccount;
